import React, { Component } from "react";
import "./Components/style.css";

class TOSAppendix extends Component {
  render() {
    return (
      <section className="contentWrapper">
        <p>
          The following terms govern dispute resolution, limitation of liability, and certain other key terms set out in
          the Casemasters Terms of Service. We provide this Appendix A as a resource for users which, at the date of
          last editing, is believed to be up to date and accurate. It is not an exhaustive list of all dispute
          resolution or limitation of liability clauses worldwide.
        </p>
        <ul>
          <li>
            <h3 className="inlined">
              <span>ARGENTINA: NON-PROFESSIONAL USERS (CONSUMERS). </span>
            </h3>
            <span>
              Argentine Consumer Law shall apply in cases where the Services, Site, or App is accessed by a consumer in
              Argentina. Any claim, dispute, or litigation from or against such consumer arising in relation to the
              validity, interpretation, or application of the Terms or any other agreement, document, or instrument
              contemplated herein, shall be adjudicated under Argentine law and shall be submitted to the Federal Courts
              of Buenos Aires.
            </span>
          </li>
          <br />
          <li>
            <h3 className="inlined">
              <span>AUSTRALIA, NEW ZEALAND, AND SOUTH AFRICA</span>
            </h3>
            <ul>
              <li>
                <span>GENERAL.</span>
                <span>
                  &nbsp;Notwithstanding the governance of the Terms and this Addendum, you may have additional
                  obligations and responsibilities to adhere to in the jurisdiction in which you practice medicine or
                  another health profession.
                </span>
              </li>
              <li>
                <span>DISPUTE RESOLUTION.</span>
                <span>
                  &nbsp;In the event that the parties consent to arbitration, the Dispute Resolution provisions in
                  Section 20 of the Terms still apply, but shall allow for the use of arbitrators based in Australia (or
                  South Africa for South African Users) rather than those based in Ontario, as well as a Court of
                  Australia (or South Africa for South African Users) in place of the Superior Court of Ontario.
                </span>
              </li>
              <li>
                <b>ADDITIONAL DISCLAIMERS.</b>

                <ul>
                  <li className="c5">
                    <span>
                      YOUR RELIANCE UPON THE CONTENT OBTAINED OR USED BY YOU THROUGH THE SITE, SERVICES, OR APP IS
                      SOLELY AT YOUR OWN RISK.
                    </span>
                  </li>
                  <li className="c5">
                    <span>
                      THE SITE, SERVICES, APP, AND COLLECTIVE CONTENT ARE PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY
                      KIND, EITHER EXPRESS OR IMPLIED. WITHOUT LIMITING THE FOREGOING, Casemasters, INC. EXPLICITLY
                      DISCLAIMS ANY WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, QUIET ENJOYMENT OR
                      NON-INFRINGEMENT, AND ANY WARRANTIES ARISING OUT OF COURSE OF DEALING OR USAGE OF TRADE.
                      Casemasters, INC. MAKES NO WARRANTY THAT THE SITE, SERVICES, APP, OR COLLECTIVE CONTENT WILL MEET
                      YOUR REQUIREMENTS OR BE AVAILABLE ON AN UNINTERRUPTED, SECURE, OR ERROR-FREE BASIS. Casemasters,
                      INC. MAKES NO WARRANTY REGARDING THE QUALITY OF ANY PRODUCTS, SERVICES, OR COLLECTIVE CONTENT
                      PURCHASED OR OBTAINED THROUGH THE SITE, SERVICES, OR APP OR THE ACCURACY, TIMELINESS,
                      TRUTHFULNESS, COMPLETENESS, OR RELIABILITY OF ANY CONTENT OBTAINED THROUGH THE SITE, SERVICES, OR
                      APP.
                    </span>
                  </li>
                  <li>
                    <span>
                      YOU MAY NOTIFY THE APP VENDOR IN THE EVENT OF ANY FAILURE OF THE APP TO CONFORM TO THE
                      ABOVE-STATED WARRANTY. THE APP VENDOR WILL REFUND THE PURCHASE PRICE OF THE Casemasters APP TO
                      YOU, BUT THE APP VENDOR WILL HAVE NO OTHER WARRANTY OBLIGATION WHATSOEVER WITH RESPECT TO THE
                      Casemasters APP.
                    </span>
                  </li>
                  <li>
                    <span>
                      NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED FROM Casemasters, INC. OR THROUGH THE
                      SITE, SERVICES, APP, OR COLLECTIVE CONTENT, WILL CREATE ANY WARRANTY NOT EXPRESSLY MADE HEREIN.
                    </span>
                  </li>
                  <li>
                    <span>
                      YOU ARE SOLELY RESPONSIBLE FOR ALL OF YOUR COMMUNICATIONS AND INTERACTIONS WITH OTHER USERS OF THE
                      SITE, SERVICES AND APP AND WITH OTHER PERSONS WITH WHOM YOU COMMUNICATE OR INTERACT WITH AS A
                      RESULT OF YOUR USE OF THE SITE, SERVICES, OR APP. YOU UNDERSTAND THAT Casemasters, INC. DOES NOT
                      TAKE RESPONSIBILITY FOR SCREENING OR INQUIRY INTO THE BACKGROUND OF ANY USERS OF THE SITE,
                      SERVICES, OR APP, NOR DOES Casemasters, INC. VERIFY OR TAKE RESPONSIBILITY FOR THE STATEMENTS OF
                      USERS OF THE SITE, SERVICES OR APP. Casemasters, INC. MAKES NO REPRESENTATIONS OR WARRANTIES AS TO
                      THE CONDUCT OF USERS OF THE SITE, SERVICES OR APP OR THEIR COMPATIBILITY WITH ANY CURRENT OR
                      FUTURE USERS OF THE SITE, SERVICES, OR APP. YOU AGREE TO TAKE REASONABLE PRECAUTIONS IN ALL
                      COMMUNICATIONS AND INTERACTIONS WITH OTHER USERS OF THE SITE, SERVICES, AND APP AND WITH OTHER
                      PERSONS WITH WHOM YOU COMMUNICATE OR INTERACT AS A RESULT OF YOUR USE OF THE SITE, SERVICES, OR
                      APP, PARTICULARLY IF YOU DECIDE TO MEET OFFLINE OR IN PERSON.
                    </span>
                  </li>
                </ul>
              </li>
              <br />
              <li>
                <h3 className="inlined">
                  <span>AUSTRALIA</span>
                  <span>: ADDITIONAL LIMITATIONS OF LIABILITY.</span>
                </h3>
                <ul>
                  <li>
                    <span>
                      IN ADDITION TO THE LIMITATION OF LIABILITY TERMS IN SECTION 14 TO THE TERMS, YOU ACKNOWLEDGE AND
                      AGREE THAT, TO THE MAXIMUM EXTENT PERMITTED BY LAW, THE ENTIRE RISK ARISING OUT OF YOUR ACCESS TO
                      AND USE OF THE SITE, SERVICES, APP, AND COLLECTIVE CONTENT REMAINS WITH YOU AND THAT ALL EXPRESS
                      OR IMPLIED WARRANTIES, REPRESENTATIONS, STATEMENTS, TERMS AND CONDITIONS RELATING TO THESE TERMS
                      THAT ARE NOT INCLUDED IN THESE TERMS ARE EXCLUDED.
                    </span>
                  </li>
                  <li>
                    <span>
                      FOR SERVICES, SITE, OR APPS ACCESSED IN AUSTRALIA, NOTHING IN THESE TERMS EXCLUDES, RESTRICTS, OR
                      MODIFIES ANY GUARANTEE, TERM, CONDITION, WARRANTY, RIGHT, OR REMEDY IMPLIED OR IMPOSED BY ANY
                      STATUTE OR REGULATION WHICH CANNOT LAWFULLY BE EXCLUDED OR LIMITED, WHICH MAY INCLUDE THE
                      AUSTRALIAN CONSUMER LAW.
                    </span>
                  </li>
                  <li>
                    <span>
                      FOR SERVICES, SITE, OR APPS ACCESSED IN AUSTRALIA, IF ANY GUARANTEE, TERM, CONDITION, OR WARRANTY
                      IS IMPLIED OR IMPOSED IN RELATION TO THESE TERMS (
                    </span>
                    <span>A NON-EXCLUDABLE PROVISION</span>
                    <span>
                      ) AND WE ARE ABLE TO LIMIT YOUR REMEDY FOR A BREACH OF SUCH NON-EXCLUDABLE PROVISION, THEN OUR
                      TOTAL LIABILITY FOR BREACH OF THE NON-EXCLUDABLE PROVISION IS LIMITED TO ONE OR MORE OF THE
                      FOLLOWING AT OUR OPTION (i) IN THE CASE OF THE APP, THE REPLACEMENT OF THE APP, OR THE SUPPLY OF
                      AN EQUIVALENT APPLICATION, OR THE PAYMENT OF THE COST OF REPLACING THE APP OR OF AN EQUIVALENT APP
                      OR THE COST OF THE REPAIR OF THE APP (ii) IN THE CASE OF THE SERVICES, THE SUPPLYING OF THE
                      SERVICES AGAIN, OR THE COST OF HAVING THE SERVICE SUPPLIED AGAIN.
                    </span>
                  </li>
                </ul>
              </li>
              <br />
              <li>
                <span>AUSTRALIA: APPLICABLE LAW.</span>
                <span>
                  &nbsp;The Terms are governed by the laws of the Province of Ontario and the laws of Canada. However,
                  you additionally represent and warrant that you have all rights, licenses, consents, and releases that
                  are necessary to grant to Casemasters, Inc. the rights in such Registered User Content, as
                  contemplated under these Terms and that your Registered User Content, by means of using the Site,
                  Services, or App does not violate the Australian Privacy Act 1988 (Cth), the New Zealand Privacy Act
                  1993, and any other Privacy Laws as stated in Section 6 of the Terms, to the extent they apply. If you
                  accessed the Services, Site, or App in Australia, Casemasters shall consent to the application of
                  Australian law in the event of a dispute regarding the application of the Terms if and only if a court
                  in Ontario determines that not applying Australian law (i) creates a significant imbalance in the
                  parties’ rights; (ii) is not reasonably necessary to protect Casemasters’s legitimate interests; and
                  (iii) would cause detriment to the consumer. Under such a determination by a court in Ontario, any
                  action arising under these Terms or any other agreement, document, or instrument contemplated herein,
                  shall be adjudicated under Australian law, and you hereby accept and irrevocably submit to the
                  jurisdiction of the courts of New South Wales and acknowledge their competence and agree to be bound
                  by any judgment thereof.
                </span>
              </li>
            </ul>
          </li>
          <li>
            <h3 className="inlined">
              <span>AUSTRIA, ARGENTINA, PORTUGAL, THE PRC, AND UZBEKISTAN: LIMITATION OF LIABILITY.</span>
            </h3>
            <span>
              &nbsp;The limitation of liability clause is not applicable to damages resulting out of or in the damaging
              of the human body, life, or health. Furthermore the limitation of liability is not applicable in case of
              gross negligence or willful misconduct.
            </span>
          </li>
          <li>
            <h3 className="inlined">
              <span>AUSTRIA: NON-PROFESSIONAL USERS (CONSUMERS).</span>
            </h3>
            <span>
              Austrian Law shall apply in any case where the Service, Site, or App is accessed by a consumer in Austria.
              Any claim, dispute or litigation from or against such consumer arising in relation to the validity,
              interpretation, or application of the Terms or any other agreement, document, or instrument contemplated
              herein, shall be adjudicated under Austrian law and shall be submitted to the jurisdiction of the courts
              of Vienna.
            </span>
          </li>
          <li>
            <h3 className="inlined">
              <span>AZERBAIJAN</span>
              <span>: LIMITATION OF LIABILITY.</span>
            </h3>
            <span>
              &nbsp;The limitation of liability clause is not applicable to damages resulting out of or in the damaging
              of the human body, life, or health, nor to damages under the Law “On the protection of consumer rights”.
              The limitation of liability clause is also not applicable to damages caused intentionally or by gross
              negligence.
            </span>
          </li>
          <li>
            <h3 className="inlined">
              <span>AZERBAIJAN: NON-PROFESSIONAL USERS (CONSUMERS). </span>
            </h3>
            <span>
              The Azerbaijan Consumer Law shall apply in any case where the Services, Site, or App is accessed by a
              consumer in Azerbaijan. Any claim, dispute, or litigation from or against such consumer arising in
              relation to the validity, interpretation, or application of the Terms or any other agreement, document, or
              instrument contemplated herein, shall be adjudicated under Azerbaijan law and shall be submitted to the
              jurisdiction of the courts of Azerbaijan.
            </span>
          </li>
          <li>
            <h3 className="inlined">
              <span>AZERBAIJAN</span>
              <span>, </span>
              <span>TURKEY</span>
              <span>, </span>
              <span>SPAIN</span>
              <span>, </span>
              <span>SWEDEN</span>
              <span>, NORWAY, FINLAND, AND ICELAND: CONSENT FROM PATIENTS.</span>
            </h3>
            <span>
              &nbsp;If you are a resident of Azerbaijan, Turkey, Spain, Sweden, Norway, Finland, or Iceland, or of any
              another jurisdiction where obtaining the patient’s consent is legally necessary, you undertake to obtain
              express consent from the patient prior to capturing images of a part of the patient’s body and
              transferring the fully de-identified image to be shared on Casemasters. You shall provide the patient with
              clear and understandable information on the purpose and consequences of your use of the image. If the
              patient is a child, consent shall be obtained from the patient’s parent or guardian.
            </span>
          </li>
          <li>
            <h3 className="inlined">
              <span>BELARUS</span>
              <span>: LIMITATION OF LIABILITY.</span>
            </h3>
            <span>
              &nbsp;The limitation of liability clause is not applicable to damages resulting from or in the damaging of
              the life, or health, or property of a consumer under the Consumer Protection Act N90-З of 9 January 2002.
            </span>
          </li>
          <li>
            <h3 className="inlined">
              <span>BELGIUM</span>
              <span>: LIMITATION OF LIABILITY.</span>
            </h3>
            <span>
              &nbsp;The limitation of liability clause is not applicable to damages resulting out of or in the damaging
              of the human body, life, or health, nor to damages under the Belgian Product Liability Act of 25 February
              1991. The limitation of liability clause is also not applicable to damages caused intentionally or by
              gross negligence.
            </span>
          </li>
          <li>
            <h3 className="inlined">
              <span>PEOPLE’S REPUBLIC OF CHINA</span>
              <span>: DISCLAIMER ON APP AND SITE.</span>
            </h3>
            <span>
              &nbsp;You acknowledge that, although Casemasters, Inc. develops the App and the Site independently, it is
              not able to conduct intellectual property clearance for the App and the Site as well as the Service in all
              jurisdictions. If the App, the Site, or the Service is found infringing, the sole liability of
              Casemasters, Inc. is that Casemasters, Inc. shall select, at its sole discretion, (i) to revise the App,
              the Site, and/or the Service to make them non-infringing; (ii) to seek a license to continue operating the
              App, the Site, and/or the Services; or (iii) to suspend the Service, in which case you shall uninstall the
              App and stop using the Site. Without prejudice to Section 18 of the Terms, you acknowledge that it is
              commercially and technically impossible for Casemasters to ensure that the programs comprising the App or
              the Site are free of error, defect, virus, or malicious code. Should any error, defect, virus, or
              malicious code be discovered or reported, Casemasters, Inc.’s sole responsibility is to use reasonable
              commercial efforts to remove such identified error, defect, virus, or malicious code.
            </span>
          </li>
          <li>
            <h3 className="inlined">
              <span>FRANCE</span>
              <span>: NON-PROFESSIONAL USERS (CONSUMERS).</span>
            </h3>
            <span>
              &nbsp;The French Consumer Law shall apply in any case where the Service, Site, or App is accessed by a
              consumer in France. Any claim, dispute, or litigation from or against such consumer arising in relation to
              the validity, interpretation, or application of the Terms or any other agreement, document, or instrument
              contemplated herein, shall be adjudicated under French law and shall be submitted to the jurisdiction of
              the courts of Paris.
            </span>
          </li>
          <li>
            <h3 className="inlined">
              <span>GERMANY</span>
              <span>: LIMITATION OF LIABILITY.</span>
            </h3>
            <span>
              &nbsp;The limitation of liability clause is not applicable to damages resulting out of or in the damaging
              of the human body, life, or health, nor to damages under the German Product Liability Act. The limitation
              of liability is not applicable to damages caused intentionally or with gross negligence or by a negligent
              violation of pivotal contractual obligations, i.e. obligations whose fulfillment is a prerequisite for the
              orderly implementation of this agreement, the violation of which endangers the attainment of the
              contractual goal and the compliance of which the other side may regularly trust. In the latter case,
              liability is limited to damages which are typically foreseeable.
            </span>
          </li>
          <li>
            <h3 className="inlined">
              <span>INDIA</span>
              <span>:</span>
            </h3>
            <span>&nbsp;In addition to your obligations under these Terms, including your obligations under the </span>
            <span>
              <a href="https://www.casemasters.com/sections/content-policy">Content Policy for Users</a>
            </span>
            <span>
              , you agree not to host, display, upload, modify, publish, transmit, update, or share any information,
              whether through the App or by way of use of the Services, that:
            </span>
            <ul>
              <li>
                <span>Belongs to another person and to which you have no right to;</span>
              </li>
              <li>
                <span>
                  Is grossly harmful, harassing, blasphemous, defamatory, obscene, pornographic, paedophillic, libelous,
                  invasive of another’s privacy, hateful, or racially orethnically objectionable, disparaging, relating
                  to or encouraging money laundering or gambling, or otherwise unlawful in any manner whatsoever;
                </span>
              </li>
              <li>
                <span>Harms minors in any way;</span>
              </li>
              <li>
                <span>Infringes any patent, trademark, copyright, or other proprietary rights;</span>
              </li>
              <li>
                <span>Violates any applicable laws</span>
              </li>
              <li>
                <span>
                  Deceives or misleads the addressee about the origin of such messages or communicates any information
                  that is grossly offensive or menacing in nature;
                </span>
              </li>
              <li>
                <span>Impersonates another person;</span>
              </li>
              <li>
                <span>
                  Contains software viruses or any other computer code, files, or programs designed to interrupt,
                  destroy, or limit the functionality of any computer resource;
                </span>
              </li>
              <li>
                <span>
                  Threatens the unity, integrity, defence, security, or sovereignty of India, friendly relations with
                  foreign states, or public order or causes incitement to the commission of any cognizable offence, or
                  prevents the investigation of any offence or is insulting to any other nation.
                </span>
              </li>
            </ul>
          </li>
          <li>
            <h3 className="inlined">
              <span>ITALY</span>
              <span>: NON-PROFESSIONAL USERS (CONSUMERS).</span>
            </h3>
            <span>
              &nbsp;Italian Consumer Law shall apply in any case where the Services, Site, or App is accessed by a
              consumer in Italy. Any claim, dispute, or litigation from or against such consumer arising in relation to
              the validity, interpretation, or application of the Terms or any other agreement, document or instrument
              contemplated herein, shall be adjudicated under Italian law and shall be submitted to the jurisdiction of
              the courts of Rome.
            </span>
          </li>
          <li>
            <h3 className="inlined">
              <span>JAPAN</span>
              <span>: NON-PROFESSIONAL USERS (CONSUMERS).</span>
            </h3>
            <span>
              &nbsp;The limitation of liability clause is not applicable in case of gross negligence or willful
              misconduct. Japanese Law shall apply in any case where the Services, Site, or App is accessed by a
              consumer in Japan. Any claim, dispute, or litigation from or against such consumer arising in relation to
              the validity, interpretation, or application of the Terms or any other agreement, document, or instrument
              contemplated herein, shall be adjudicated under Japanese law and shall be exclusively submitted to the
              jurisdiction of the courts of Tokyo.
            </span>
          </li>
          <li>
            <h3 className="inlined">
              <span>KAZAKHSTAN</span>
              <span>: LIMITATION OF LIABILITY.</span>
            </h3>
            <span>
              &nbsp;The limitation of liability clause is not applicable to damages to life, health, or property of the
              person, who used the services solely for consumer purposes, resulting out of defects of the services or
              incorrect or incomplete information about the services. The total liability of Casemasters, Inc. for
              breach of these Terms of Service shall be limited to the real damage, caused to you due to such breach.
              The limitation of liability is not applicable to damages caused intentionally.
            </span>
          </li>
          <li>
            <h3 className="inlined">
              <span>LATIN AMERICA</span>
              <span>: CONSENT FROM PATIENTS.</span>
            </h3>
            <span>
              &nbsp;If you are a resident of Argentina or of any another jurisdiction in Latin America where obtaining
              the patient’s consent is legally necessary, you undertake to obtain express consent from the patient prior
              to capturing images of a part of the patient’s body and transferring the fully de-identified image to be
              shared on Casemasters. You shall provide the patient with clear and understandable information on the
              purpose and consequences of your use of the image. If the patient is a child, consent shall be obtained
              from the patient’s parent or guardian.
            </span>
          </li>
          <li>
            <h3 className="inlined">
              <span>LEBANON</span>
              <span>:</span>
            </h3>
            <span>
              &nbsp;The imperative provisions of the Consumer Protection Law No. 659 dated 4 February 2005 shall apply
              in any case where the Services, Site, or App is accessed by a consumer in Lebanon. By clicking on the
              “AGREE” or “I ACCEPT” button or accessing or using the Site, Services, or App, you are confirming your
              approval to have this Agreement, the Terms of Service, drafted in the English Language.
            </span>
          </li>
          <li>
            <h3 className="inlined">
              <span>RUSSIAN FEDERATION</span>
              <span>:</span>
            </h3>
            <ul>
              <li>
                <span>NON-PROFESSIONAL USERS (CONSUMERS).</span>
                <span>
                  &nbsp;If the Services, Site, or App is accessed by a consumer in the Russian Federation and the Law
                  which is applicable under these Terms deprives a consumer of their rights, which are given by
                  peremptory rules of the Russian Law, the Russian law shall apply.
                </span>
              </li>
              <li>
                <span>LIMITATION OF LIABILITY.</span>
                <span>
                  &nbsp;The limitation of liability clause is not applicable to damages resulting out of or in the
                  damage of the human body, life, or health. Furthermore the limitation of liability is not applicable
                  in case of wilful misconduct.
                </span>
              </li>
              <li>
                <span>ADDITIONAL PROHIBITIONS.</span>
                <span>
                  &nbsp;In addition to your obligations under these Terms, including your obligations under the{" "}
                </span>
                <span>
                  <a href="https://www.casemasters.com/sections/content-policy">Content Policy for Users</a>
                </span>
                <span>
                  , you agree not to host, display, upload, modify, publish, transmit, update or share any information,
                  whether through the App or by way of use of the Services, that contain pornographic, abusive,
                  extremist, or other materials prohibited by Russian law.
                </span>
              </li>
            </ul>
          </li>
          <li>
            <h3 className="inlined">
              <span>SOUTH AFRICA</span>
              <span>: DISPUTE RESOLUTION.</span>
            </h3>
            <span>
              &nbsp;If you accessed the Services, Site, or App in South Africa, Casemasters shall consent to the
              application of South African law in the event of a dispute regarding the application of the Terms if and
              only if a court in Ontario determines that not applying South African law (i) creates a significant
              imbalance in the parties’ rights; (ii) is not reasonably necessary to protect Casemasters’s legitimate
              interests; and (iii) would cause detriment to the consumer. Under such a determination by a court in
              Ontario, any action arising under these Terms or any other agreement, document, or instrument contemplated
              herein, shall be adjudicated under South African law and you hereby accept and irrevocably submit to the
              jurisdiction of the courts of South Africa and acknowledge their competence and agree to be bound by any
              judgment thereof.
            </span>
          </li>
          <li>
            <h3 className="inlined">
              <span>SPAIN</span>
              <span>: NON-PROFESSIONAL USERS (CONSUMERS).</span>
            </h3>
            <span>
              &nbsp;Spanish Consumer Law shall apply in any case where the Services, Site, or App is accessed by a
              consumer in Spain. Any claim, dispute, or litigation from or against such consumer arising in relation to
              the validity, interpretation, or application of the Terms or any other agreement, document, or instrument
              contemplated herein, shall be adjudicated under Spanish law and shall be submitted to the jurisdiction of
              the courts of Madrid.
            </span>
          </li>
          <li>
            <h3 className="inlined">
              <span>TURKEY:</span>
            </h3>
            <ul>
              <li>
                <span>LIMITATION OF LIABILITY.</span>
                <span>
                  &nbsp;The limitation of liability clause is not applicable to damages resulting out of or in the
                  damaging of the human body, life, or health, nor to damages under Turkey’s Product Liability
                  Regulations. The limitation of liability is not applicable to damages caused intentionally or with
                  gross negligence or by a negligent violation of pivotal contractual obligations, i.e. obligations
                  whose fulfillment is a prerequisite for the orderly implementation of this agreement, the violation of
                  which endangers the attainment of the contractual goal and the compliance of which the other side may
                  regularly trust. In the latter case, liability is limited to damages which are typically foreseeable.
                </span>
              </li>
              <li>
                <span>NON-PROFESSIONAL USERS (CONSUMERS).</span>
                <span>
                  &nbsp;Turkish Consumer Law shall apply in any case where the Services, Site, or App is accessed by a
                  consumer in Turkey. Any claim, dispute, or litigation from or against such consumer arising in
                  relation to the validity, interpretation, or application of the Terms or any other agreement,
                  document, or instrument contemplated herein, shall be adjudicated under Turkish law and shall be
                  submitted to the jurisdiction of the courts of İstanbul.
                </span>
              </li>
            </ul>
          </li>
          <li>
            <h3>
              <span>UKRAINE:</span>
            </h3>
            <ul>
              <li>
                <span>LIMITATION OF LIABILITY.</span>
                <span>
                  &nbsp;The limitation of liability clause is not applicable in case of death or damage of health
                  resulting from actions or omissions of Casemasters, Inc.
                </span>
              </li>
              <li>
                <span>NON-PROFESSIONAL USERS (CONSUMERS).</span>
                <span>
                  &nbsp;Ukrainian Law shall apply in any case where the Services, Site, or App is accessed by a consumer
                  in Ukraine. Any claim, dispute, or litigation from or against such consumer arising in relation to the
                  validity, interpretation, or application of the Terms or any other agreement, document, or instrument
                  contemplated herein, shall be adjudicated under Ukrainian law and shall be submitted to the
                  jurisdiction of the courts of Ukraine.
                </span>
              </li>
              <li>
                <span>CONSENT FROM PATIENTS.</span>
                <span>
                  &nbsp;If you are a resident of Ukraine or of any other jurisdiction where obtaining the patient’s
                  consent is legally necessary, you undertake to obtain express consent from the patient prior to
                  capturing images of a part of the patient’s body and transferring the fully de-identified image to be
                  shared on Casemasters. You shall provide the patient with clear and understandable information on the
                  purpose and consequences of your use of the image. If the patient has died, such consent shall be
                  received from the patient’s children, widow (widower) or in case of the absence of such relatives –
                  the patient’s parents, sisters, and brothers.
                </span>
              </li>
            </ul>
          </li>
          <li>
            <h3 className="inlined">
              <span>UZBEKISTAN</span>
              <span>: NON-PROFESSIONAL USERS (CONSUMERS).</span>
            </h3>
            <span>
              Uzbekistan Consumer Law shall apply in cases where a consumer in Uzbekistan accesses the Services, Site,
              or App. Any claim, dispute, or litigation from or against such consumer arising in relation to the
              validity, interpretation, or application of the Terms or any other agreement, document, or instrument
              contemplated herein, shall be adjudicated under Uzbekistan law and shall be submitted to the jurisdiction
              of the courts of Tashkent city.
            </span>
          </li>
        </ul>
      </section>
    );
  }
}

export default TOSAppendix;



// WEBPACK FOOTER //
// ./src/scenes/Sections/TOSAppendix.js